// extracted by css-extract-rspack-plugin
export default {"wrapper":"_ad6d7cd0","colWrapper":"_13690bf0","projectTile":"_80b39ba2","projectImage":"_c0a8fb11","projectInfo":"_54081c98"};